import { SocialCommitmentTypeSpend } from "@interfaces/commitment";
import { ContractorPackageLineItem } from "@interfaces/contractorPackage";
import {
  SocialProcurement,
  SocialProcurementEntityType,
  SocialProcurementLineItem,
} from "@interfaces/socialProcurement";

export const decodeSocialProcurement = (
  socialProcurement: SocialProcurement
): SocialProcurementLineItem => {
  return {
    id: socialProcurement.social_procurement_id,
    reportId: socialProcurement.contractor_report_id,
    transactionDate: new Date(socialProcurement.transaction_date),
    supplier: socialProcurement.supplier,
    abn: socialProcurement.abn,
    supplierCountry: socialProcurement.supplier_country,
    supplyPostCode: socialProcurement.supply_post_code,
    geoLocation: {
      lat: socialProcurement.geo_location_lat,
      lng: socialProcurement.geo_location_long,
    },
    invoiceReference: socialProcurement.invoice_reference,
    natureOfExpenditure: socialProcurement.nature_of_expenditure,
    invoiceValue: socialProcurement.invoice_value,
    copyOfInvoice: socialProcurement.copy_of_invoice,
    comments: socialProcurement.comments,
    socialFactors: socialProcurement.social_factors,
    created: new Date(socialProcurement.created),
    entityType: decodeSocialProcurementEntityType(
      socialProcurement.entity_type
    ),
  };
};

export const encodeSocialProcurement = (
  socialProcurement: SocialProcurementLineItem
): SocialProcurement => {
  return {
    social_procurement_id: socialProcurement.id,
    contractor_report_id: socialProcurement.reportId,
    transaction_date: socialProcurement.transactionDate,
    supplier: socialProcurement.supplier,
    abn: socialProcurement.abn,
    supplier_country: socialProcurement.supplierCountry,
    supply_post_code: socialProcurement.supplyPostCode,
    geo_location_lat: socialProcurement.geoLocation.lat,
    geo_location_long: socialProcurement.geoLocation.lng,
    invoice_reference: socialProcurement.invoiceReference,
    nature_of_expenditure: socialProcurement.natureOfExpenditure,
    invoice_value: socialProcurement.invoiceValue,
    copy_of_invoice: socialProcurement.copyOfInvoice,
    comments: socialProcurement.comments,
    social_factors: socialProcurement.socialFactors,
    created: socialProcurement.created,
    entity_type: encodeSocialProcurementEntityType(
      socialProcurement.entityType
    ),
  };
};

export const decodeSocialProcurementEntityType = (
  entityType: string
): SocialProcurementEntityType => {
  switch (entityType) {
    default:
    case "social-procurement-entity-type_social-enterprise":
      return SocialProcurementEntityType.SocialEnterprise;
    case "social-procurement-entity-type_disability-enterprise":
      return SocialProcurementEntityType.DisabilityEnterprise;
    case "social-procurement-entity-type_indigenous-enterprise":
      return SocialProcurementEntityType.IndigenousEnterprise;
  }
};

const encodeSocialProcurementEntityType = (
  entityType: SocialProcurementEntityType
): string => {
  switch (entityType) {
    case SocialProcurementEntityType.SocialEnterprise:
      return "social-procurement-entity-type_social-enterprise";
    case SocialProcurementEntityType.DisabilityEnterprise:
      return "social-procurement-entity-type_disability-enterprise";
    case SocialProcurementEntityType.IndigenousEnterprise:
      return "social-procurement-entity-type_indigenous-enterprise";
  }
};
const encodeSocialCommitmentTypeSpend = (
  commitmentType: SocialCommitmentTypeSpend
): string => {
  switch (commitmentType) {
    case SocialCommitmentTypeSpend.DefaultSpend:
      return "social-commitment-type_default-spend";
    case SocialCommitmentTypeSpend.LocalContent:
      return "social-commitment-type_local-content";
    case SocialCommitmentTypeSpend.SocialDisabilityEnterpriseSpend:
      return "social-commitment-type_social-disability-enterprise-spend";
    case SocialCommitmentTypeSpend.AboriginalTorresStraitIslanderBusinessSpend:
      return "social-commitment-type_aboriginal-torres-strait-island-buseinss-spend";
  }
};

const decodeSocialCommitmentTypeSpend = (
  commitmentType: string
): SocialCommitmentTypeSpend => {
  switch (commitmentType) {
    default:
    case "social-commitment-type_default-spend":
      return SocialCommitmentTypeSpend.LocalContent;
    case "social-commitment-type_social-disability-enterprise-spend":
      return SocialCommitmentTypeSpend.SocialDisabilityEnterpriseSpend;
    case "social-commitment-type_aboriginal-torres-strait-island-buseinss-spend":
      return SocialCommitmentTypeSpend.AboriginalTorresStraitIslanderBusinessSpend;
  }
};

const encodeSocialCommitmentType = (
  commitmentType: SocialCommitmentTypeSpend
): string => {
  switch (commitmentType) {
    case SocialCommitmentTypeSpend.DefaultSpend:
      return "social-commitment-type_default-spend";
    case SocialCommitmentTypeSpend.LocalContent:
      return "social-commitment-type_local-content";
    case SocialCommitmentTypeSpend.SocialDisabilityEnterpriseSpend:
      return "social-commitment-type_social-disability-enterprise-spend";
    case SocialCommitmentTypeSpend.AboriginalTorresStraitIslanderBusinessSpend:
      return "social-commitment-type_aboriginal-torres-strait-island-buseinss-spend";
  }
};

export const getSocialProcurementFactors = (
  contractorPackage: ContractorPackageLineItem,
  socialProcurement: SocialProcurementLineItem
) => {
  const socialFactors: string[] = [];

  //TODO: Get new geo-region
  // if (socialProcurement.geoLocation) {
  //   const factor = contractorPackage.commitments.find(
  //     (c) => c.targetName === SocialCommitmentTypeSpend.LocalContent
  //   );
  //   if (factor) {
  //     socialFactors.push(factor.id);
  //   }
  // }
  if (
    [
      SocialProcurementEntityType.DisabilityEnterprise,
      SocialProcurementEntityType.SocialEnterprise,
    ].includes(socialProcurement.entityType)
  ) {
    const factor = contractorPackage.commitments.find(
      (c) =>
        c.targetName ===
        SocialCommitmentTypeSpend.SocialDisabilityEnterpriseSpend
    );
    if (factor) {
      socialFactors.push(factor.id);
    }
  }
  if (
    [SocialProcurementEntityType.IndigenousEnterprise].includes(
      socialProcurement.entityType
    )
  ) {
    const factor = contractorPackage.commitments.find(
      (c) =>
        c.targetName ===
        SocialCommitmentTypeSpend.AboriginalTorresStraitIslanderBusinessSpend
    );
    if (factor) {
      socialFactors.push(factor.id);
    }
  }
  return socialFactors;
};
